import _ from 'lodash'
import Backbone from 'backbone'
import globals from 'scoreboard/components/globals'
import Dataset from '../model/dataset'

/**
 * Drills down to the view that created a dataset series
 * @param {Object} datasetSeries the dataset series, as stored in the series.equation
 * field
 */
function datasetSeriesDrilldown(datasetSeries) {
	let request = _.pick(datasetSeries, 'id', 'aggregationType',
		'aggregationFieldId', 'aggregationVisibleLinkedFieldId')
	request.filters = datasetSeries.filters
	createPeriodFilter({ datasetSeries, request})
	let options = { request, datasetSeries }
	Backbone.trigger(Dataset.DRILLDOWN, datasetSeries.id, options)
}

/**
 * Starting in #44194 we add a filter when drilling from a scorecards overview
 * to the datasets section for non-snapshot metrics
 */
function createPeriodFilter({ datasetSeries, request}) {
	if (datasetSeries.calendarFieldId &&
		datasetSeries.calendarFieldId != Dataset.SNAPSHOT) {
		let filter = {
			operator: 'in-any-period',
			periodIds: [globals.periodId],
			fieldId: datasetSeries.calendarFieldId,
			visibleLinkedFieldId: datasetSeries.calendarVisibleLinkedFieldId,
			isGlobalCalendarFilter: true
		}
		request.filters = [filter].concat(request.filters)
	}
}

export default datasetSeriesDrilldown

datasetSeriesDrilldown.__filename__ = 'datasets/overview/dataset-series-drilldown.js'
